/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import template from './views/performing_section.html';
import controller from './controllers/performingsectionController';
var module = angular.module('performingSection', [
    //import modules
]).controller('performingSection', controller);

module.constant('performingSection', {
})
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('performingSection', {
//             parent: 'app',
//             url: '/performing-section',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'performingSection'
//                 }
//             }
//         })

// });



// WEBPACK FOOTER //
// ./src/app/educore_reports/school/performingsection.js